module.exports = __webpack_public_path__ + "static/footer-4-9f0b27f9a54ade3cac3a6514920b999a.jpg";